

   <div *ngIf="slideOutVisible" @slideInOut class="fixed inset-y-0 right-0 w-screen max-w-md bg-white shadow-xl z-[95] transform transition-transform overflow-y-auto" [ngClass]="{'translate-x-full': !slideOutVisible, 'translate-x-0': slideOutVisible}">
    <div class="h-full flex flex-col bg-white shadow-xl">
      <div class="px-4 py-3 bg-gray-50 sm:px-4">
        <div class="flex items-start justify-between">
          <h2 class="text-lg font-medium text-gray-900">Sublet Selection</h2>
          <div class="ml-3 h-7 flex items-center">
            <button (click)="closeSlideOut()" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500">
              <span class="sr-only">Close panel</span>
              <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="px-4 py-4 sm:px-6 flex-1">
        <form [formGroup]="subletForm">
          <div class="space-y-4">
            <ng-container *ngFor="let option of options; trackBy: trackByName">
              <ng-container *ngIf="!option.isSubcategory">
              <button (click)="selectOption(option)" class="relative w-full flex justify-between py-3 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-900 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                {{ option.name }}
                <span *ngIf="option.selected" class="absolute right-3 top-3 h-4 w-4 bg-green-500 rounded-full"></span>
              </button>
              <!-- Secondary List for Glass Sublet -->
              <!-- <div *ngIf="option.name === 'Glass' && option.selected" class="mt-2 space-y-2">
                <h3 class="text-sm font-medium text-gray-700">Glass Sublet Options</h3>
                <div formArrayName="glassOptions" class="space-y-2">
                  <div *ngFor="let glassOption of glassOptions.controls; let i = index; trackBy: trackByIndex" class="flex items-center">
                    <input type="checkbox" [formControlName]="i" (change)="selectOption(option, i)" class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500">
                    <label class="ml-2 block text-sm text-gray-900">{{ option.subcategories[i].name }}</label>
                  </div>
                </div>
              </div> -->
              </ng-container>
            </ng-container>
            <button (click)="resetOptions()" class="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              Clear Selection(s)
            </button>
          </div>
      
          <div class="space-y-2 mt-6" *ngIf="isAnyParentSubletSelected">
            <button (click)="submit()" class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
              Add Selection(s)
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  
